import { IAccessConfig, IInviteUser } from '@/modules/login/services/access-service/access-service.types';
import { storageService, httpClient } from '@/shared/services';
import { configs } from '@/shared/configs';

const ACCESS_API = '/api/v1/access/public';
const ACCESS_SESSIONS_API = `${ACCESS_API}/access-sessions`;
const ACCESS_INVITE_URL = `${ACCESS_SESSIONS_API}/otp`;

function getSessionConfig(accessSessionId: string): Promise<IAccessConfig> {
  return httpClient.client
    .get(`${ACCESS_SESSIONS_API}/${accessSessionId}/configuration`)
    .then(res => res.data as IAccessConfig)
    .catch(error => {
      throw error('Failed to load access session');
    });
}

function inviteUser(userId: string, sendEmail = false, organizationName = '') {
  const accessSessionId = storageService.session.get(configs.SESSION_ID_KEY);
  const lang = storageService.session.get('lang');

  let endpoint = `${ACCESS_INVITE_URL}/${accessSessionId}`;

  if (lang) {
    endpoint += `?lang=${lang}`;
  }

  return httpClient.client.post<IInviteUser>(endpoint, { userId, sendEmail });
}

export const getAccessSessionConfiguration = getSessionConfig;
export const sendInviteToUser = inviteUser;
